import {rewriteAssetUrl} from '@service/scripts/components/helpers.jsx';

export function SimpleImage({cdaEntry, maxWidth}) {
    const imageUrl = cdaEntry.fields.image?.fields.file.url;

    if (!imageUrl) {
        return null;
    }
    const url = rewriteAssetUrl(`https:${cdaEntry.fields.image.fields.file.url}?w=${maxWidth}`);
    const imageWidth = cdaEntry.fields.image.fields.file.details.image.width > maxWidth ? maxWidth : cdaEntry.fields.image.fields.file.details.image.width;
    //calc imageHeight based on aspect ratio
    let imageHeight = cdaEntry.fields.image.fields.file.details.image.height;
    if (cdaEntry.fields.image.fields.file.details.image.width > maxWidth) {
        const aspectRatio = cdaEntry.fields.image.fields.file.details.image.width / cdaEntry.fields.image.fields.file.details.image.height;
        imageHeight = Math.round(imageWidth / aspectRatio);
    }

    return (
        <img            
            src={ url }
            alt={ cdaEntry.fields.altText }
            width={ imageWidth }
            height={ imageHeight }
            loading="lazy"
        />
    );
}